export default __webpack_public_path__ + "static/media/MP.689a6e2d.svg";